import request from "@/utils/request";
import { DeviceCmd, DeviceCmdItemAction } from '@/types/device-cmd'
const CMD_API_PREFIX = '/uav/control'

export interface SendCmdParams {
  dock_sn: string, // 机场cn
  device_cmd: DeviceCmd // 指令
}

export interface PostSendCmdBody {
  action: DeviceCmdItemAction,
  sn:String,
  serviceIdentifier?:String,
}
/**
 * 发送机场控制指令
 * @param params
 * @returns
 */
// /control/api/v1/devices/{dock_sn}/jobs/{service_identifier}
export async function postSendCmd (body?: PostSendCmdBody): Promise<{}> {
  const resp = await request.post(`${CMD_API_PREFIX}/dock/jobs`, body)
  return resp.data
}

/**
 * 一键标定
 * @param params
 * @returns
 */
export const rtkCalibration = async (body: any): Promise<any> => {
  const url = `/uav/control/dock/rtkCalibration`;
  const result = await request.post(url, body);
  return result.data;
};
